import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { ComponentType } from '@angular/cdk/portal';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private dialogRef: Array<MatDialogRef<any>> = [];
  public closeEvent: Subject<any> = new Subject();

  constructor(public dialog: MatDialog) { }

  public open<T> (component: ComponentType<T>, data: any = null, options: any = {}){
    this.dialogRef.push(this.dialog.open(component, {
      data: data,
      disableClose: true,
      ...options
    }));
  }

  public close(data = null) {
    this.dialogRef.pop().close();
    this.closeEvent.next(data);
  }
}
